import CircleIcon from '@mui/icons-material/Circle';
import { keyframes } from '@mui/system';
import React from 'react';

const pulse = keyframes`
  0% {
    opacity: 0.5;
    transform: scale(0.8);
    filter: drop-shadow(0 0 0 rgba(0, 255, 0, 0.7));
  }
  50% {
    opacity: 1;
    transform: scale(1);
    filter: drop-shadow(0 0 6px rgba(0, 255, 0, 0.7));
  }
  100% {
    opacity: 0.5;
    transform: scale(0.8);
    filter: drop-shadow(0 0 0 rgba(0, 255, 0, 0));
  }
`;

const PulsingActiveIcon: React.FC = () => {
  return (
    <CircleIcon
      sx={{
        color: '#00ff00',
        fontSize: 'clamp(0.4rem, 0.8vw, 0.8rem)',
        animation: `${pulse} 2s ease-in-out infinite`,
        borderRadius: '50%',
        filter: 'drop-shadow(0 0 2px rgba(0, 255, 0, 0.5))',
      }}
    />
  );
};

export default PulsingActiveIcon;
